// Translation mapping for hotel facilities from English to Hebrew
export const facilitiesTranslation = {
  "Family rooms": "חדרים למשפחה",
  "Swimming pool": "בריכת שחייה",
  "Free car parking": "חניה חינם",
  "Outdoor pool": "בריכה חיצונית",
  "Non smoking rooms": "חדרים ללא עישון",
  "Fitness Center": "מרכז כושר",
  "Parking": "חניה",
  "Restaurant(s)": "מסעדה/ות",
  "Wifi": "WiFi",
  "Room Service": "שירות חדרים",
  "Spa": "ספא",
  "24 Hour Front Desk": "קדם קבלה 24 שעות",
  "Bars": "ברים",
  "Laundry Service": "שירות כביסה",
  "Dry cleaning service": "שירות ניקוי יבש",
  "Games room": "חדר משחקים",
  "Iron and board": "מגהץ ולוח גיהוץ",
  "Internet access": "גישה לאינטרנט",
  "Lifts": "מעליות",
  "Safe": "כספת",
  "Lunch": "ארוחת צהריים",
  "Luggage storage": "אחסון מזוודות",
  "Mini Golf": "מיני גולף",
  "Air conditioning": "מיזוג אוויר",
  "Smoking area": "אזור עישון",
  "Shuttle service": "שירות הסעות",
  "Housekeeping": "ניקיון",
  "Wheelchair accessible": "נגיש לכיסא גלגלים",
  "WC": "שירותים",
  "Bathroom": "חדר אמבטיה",
  "Salt water pool": "בריכת מי מלח",
  "Coffee": "קפה",
  "Beach nearby": "חוף קרוב",
  "24H. Security": "אבטחה 24 שעות",
  "Security Features": "אמצעי אבטחה",
  "Smoke detector": "גלאי עשן",
  "TV": "טלוויזיה",
  "Cleaning": "ניקיון",
  "First aid": "עזרה ראשונה",
  "Minibar": "מיני בר",
  "Shower": "מקלחת",
  "Telephone": "טלפון",
  "Hairdryer": "מייבש שיער",
  "Desk": "שולחן כתיבה",
  "Sofa bed": "ספה נפתחת",
  "Carpeted": "מרוצף שטיחים",
  "Wake-Up service": "שירות השכמה",
  "Towels": "מגבות",
  "Sink": "כיור",
  "Water": "מים",
  "Cot": "עריסה",
  "Gymnasium": "מכון כושר",
};

/**
 * Translates a facility name from English to Hebrew
 * @param {string} facilityName - The English facility name
 * @param {string} currentLanguage - The current language code (default: 'he')
 * @returns {string} - The translated facility name or the original if translation not found
 */
export const translateFacility = (facilityName, currentLanguage = 'he') => {
  if (!facilityName) return facilityName;
  
  // If language is Hebrew, translate to Hebrew
  if (currentLanguage === 'he') {
    // Try exact match first
    if (facilitiesTranslation[facilityName]) {
      return facilitiesTranslation[facilityName];
    }
    
    // Try case-insensitive match
    const normalizedName = facilityName.trim();
    const lowerName = normalizedName.toLowerCase();
    
    // Find case-insensitive match
    for (const [key, value] of Object.entries(facilitiesTranslation)) {
      if (key.toLowerCase() === lowerName) {
        return value;
      }
    }
    
    // Try partial match (contains)
    for (const [key, value] of Object.entries(facilitiesTranslation)) {
      if (lowerName.includes(key.toLowerCase()) || key.toLowerCase().includes(lowerName)) {
        return value;
      }
    }
    
    // Return original if no translation found
    return facilityName;
  }
  
  // For other languages, return the original English name
  return facilityName;
};


